// src/pages/HarvestAnalytics.js  
import React from 'react';  
  
const HarvestAnalytics = () => <div>収穫分析ページ</div>;  
  
export default HarvestAnalytics;  
